// Shared logic for leaving quotation page. Do not modify if you are not sure what you are doing
export const leaveQuote = {
  data() {
    return {
      routeTo: undefined,
      // Skip prompt to use internally only
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    doExit() {
      try {
        this.skipPrompt = true
        this.$router.push(this.routeTo.path)
      } catch (e) { }
    },
    async doSaveAndExit() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote', true)
    }
  },
  // If user tries to leave this quotation, it will prompt leave message
  beforeRouteLeave(to, from, next) {
    if (this.skipPrompt) {
      next()
    } else {
      if (this.$store.state.agency.quotation.promptWhenExit) {
        this.routeTo = to
        this.promptLeave = true
        next(false)
      } else {
        next()
      }
    }
  },
  created() {
    this.$root.$on('leaveQuote', () => {
      this.doExit()
    })
  },
  beforeDestroy() {
    this.$root.$off('leaveQuote')
  }
}
